:root ._dsp-flex{display:flex;}
:root ._fb-auto{flex-basis:auto;}
:root ._bxs-border-box{box-sizing:border-box;}
:root ._pos-relative{position:relative;}
:root ._minH-t-size-medi3736{min-height:var(--t-size-medium);}
:root ._minW-t-size-medi3736{min-width:var(--t-size-medium);}
:root ._shrink-0{flex-shrink:0;}
:root ._fd-column{flex-direction:column;}
:root ._items-center{align-items:center;}
:root ._justify-center{justify-content:center;}
:root ._btlr-100000px{border-top-left-radius:100000px;}
:root ._btrr-100000px{border-top-right-radius:100000px;}
:root ._bbrr-100000px{border-bottom-right-radius:100000px;}
:root ._bblr-100000px{border-bottom-left-radius:100000px;}
:root ._pt-0px{padding-top:0px;}
:root ._pr-0px{padding-right:0px;}
:root ._pb-0px{padding-bottom:0px;}
:root ._pl-0px{padding-left:0px;}
:root ._width-t-size-medi3736{width:var(--t-size-medium);}
:root ._height-t-size-medi3736{height:var(--t-size-medium);}
:root ._maxW-t-size-medi3736{max-width:var(--t-size-medium);}
:root ._maxH-t-size-medi3736{max-height:var(--t-size-medium);}
:root ._bg-primary{background-color:var(--primary);}
:root ._bg-divider{background-color:var(--divider);}
:root ._items-stretch{align-items:stretch;}
:root ._minH-0px{min-height:0px;}
:root ._minW-0px{min-width:0px;}
:root ._shrink-1{flex-shrink:1;}
:root ._height-10px{height:10px;}
:root ._grow-1{flex-grow:1;}